class Max {
    validate(data, max) {
        return {
            isValid: `${data}`.length <= Number(max),
            additionalData: {
                max: max
            }
        };
    }
}
export default Max;
